// extracted by mini-css-extract-plugin
module.exports = {"triangle":"styles_triangle__2se8d","volumes":"styles_volumes__13xmY","helpMessage":"styles_helpMessage__3hoEg","total":"styles_total__3ekVV"};